import clsx from "clsx";
import { z } from "zod";
import { Btn } from "@/ui/btn/Btn";
import type { IconProps } from "../icon/Icon";
import styles from "./Alert.module.css";

export const AlertSchema = z.object({
  className: z.string().optional(),
  title: z.string().optional(),
  text: z.string().optional(),
  appearance: z.literal(["blue", "orange", "red"]).optional(),
  size: z.literal(["sm", "md"]).optional(),
  btn: z
    .object({
      icon: z.string() as unknown as z.ZodLiteral<IconProps["name"]>,
      text: z.string(),
      href: z.string(),
    })
    .optional(),
});

export type AlertProps = z.infer<typeof AlertSchema>;

export const Alert: React.FC<AlertProps> = ({
  className,
  title,
  text,
  appearance,
  size = "md",
  btn,
}) => {
  return (
    <div
      className={clsx(
        styles.alert,
        styles[`color-${appearance}`],
        styles[`size-${size}`],
        className,
      )}
    >
      <div className={styles.content}>
        {title !== undefined && <div className={styles.title}>{title}</div>}
        {text !== undefined && <div className={styles.text}>{text}</div>}
      </div>
      {btn !== undefined && (
        <div className={styles.controls}>
          {[btn].flat().map((btn, index) => (
            <Btn key={index} size={size} {...btn} />
          ))}
        </div>
      )}
    </div>
  );
};
